import React, {useEffect, useState} from "react";
import {BusinnesWrap} from "components/atoms/BusinessSetup/BusinessSetup.styles";
import Heading from "components/atoms/Auth/Heading";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Button from "components/molecules/Button";
import ModalContainer from "components/molecules/ModalContainer";
import PreviewModal from "./PreviewModal";
import {useDispatch} from "react-redux";
import {setBusinessSetup3} from "store/reducers/businessSlice";
import {useSelector} from "react-redux";
import Toast from "components/molecules/Toast";
import CenterModal from "components/molecules/Modal/CenterModal";

const BusinessBranding = ({setFormData, setCurrentStep, currentStep, totalSteps, prevData, formData}) => {
    const [form] = useForm();
    const dispatch = useDispatch();
    const [previewModal, setPreviewModal] = useState(false);
    const [error, setError] = useState({
        logoError: false,
        bannerError: false,
    });
    const {businessSetup3} = useSelector(state => state.business);

    // useEffect(() => {
    //     if (Object.keys(prevData).length > 0 && currentStep === 1) {
    //         form.setFieldsValue({
    //             upload_image: prevData?.logo,
    //             upload_banner: prevData?.banner,
    //         });
    //     }
    // }, [prevData, currentStep, form]);

    // function handleSubmit(e) {
    //     setFormData(prev => ({
    //         ...prev,
    //         step3: {
    //             logo: e.upload_image,
    //             banner: e.upload_banner,
    //         },
    //         logo: e.upload_image,
    //         banner: e.upload_banner,
    //     }));
    //     dispatch(setBusinessSetup3({logo: e.upload_image, banner: e.upload_banner}));
    // }

    function handleSubmit(e) {
        const logoFile = e.upload_image;
        const bannerFile = e.upload_banner;

        // Helper function for resolution check
        const checkImageResolution = (file, expectedWidth, expectedHeight) => {
            return new Promise(resolve => {
                const img = new Image();
                img.onload = () => {
                    resolve(img.width === expectedWidth && img.height === expectedHeight);
                };
                img.onerror = () => resolve(false);
                img.src = URL.createObjectURL(file);
            });
        };

        const validateFiles = async () => {
            let errorFound = false;

            // Validate Logo
            // if (logoFile) {
            //     if (logoFile.size < 1024 * 1024) {
            //         Toast({type: "error", message: "Logo size must be at least 1 MB"});
            //         setError(prev => ({...prev, logoError: "Logo size must be at least 1 MB"}));
            //         errorFound = true;
            //     } else {
            //         const validResolution = await checkImageResolution(logoFile, 150, 150);
            //         if (!validResolution) {
            //             Toast({type: "error", message: "Logo resolution must be 150px X 150px"});
            //             setError(prev => ({...prev, logoError: "Logo resolution must be 150px X 150px"}));
            //             errorFound = true;
            //         } else {
            //             setError(prev => ({...prev, logoError: ""}));
            //         }
            //     }
            // }

            // Validate Banner
            // if (bannerFile) {
            //     if (bannerFile.size < 1024 * 1024) {
            //         Toast({type: "error", message: "Banner size must be at least 1 MB"});
            //         setError(prev => ({...prev, bannerError: "Banner size must be at least 1 MB"}));
            //         errorFound = true;
            //     } else {
            //         const validResolution = await checkImageResolution(bannerFile, 1317, 440);
            //         if (!validResolution) {
            //             Toast({type: "error", message: "Banner resolution must be 1317px X 440px"});
            //             setError(prev => ({...prev, bannerError: "Banner resolution must be 1317px X 440px"}));
            //             errorFound = true;
            //         } else {
            //             setError(prev => ({...prev, bannerError: ""}));
            //         }
            //     }
            // }

            // Only proceed if no errors
            if (!errorFound) {
                console.log("no error");
                setFormData(prev => ({
                    ...prev,
                    step3: {
                        logo: logoFile,
                        banner: bannerFile,
                    },
                    logo: logoFile,
                    banner: bannerFile,
                }));

                dispatch(setBusinessSetup3({logo: logoFile, banner: bannerFile}));

                setPreviewModal(true);
            }
        };

        validateFiles();
    }

    useEffect(() => {
        if (businessSetup3?.logo instanceof File) {
            form.setFieldsValue({
                upload_image: businessSetup3.logo,
            });
        }
    }, [businessSetup3?.logo]);

    useEffect(() => {
        if (businessSetup3?.banner instanceof File) {
            form.setFieldsValue({
                upload_banner: businessSetup3.banner,
            });
        }
    }, [businessSetup3?.banner]);

    return (
        <BusinnesWrap>
            <Heading
                heading="Upload Your"
                ColoredText="Branding"
                para="Make your restaurant stand out with a logo and banner."
            />
            <CenterModal open={previewModal} setOpen={setPreviewModal} width="994" title="How It Will Look:">
                <PreviewModal setCurrentStep={setCurrentStep} formData={formData} />
            </CenterModal>
            <Form form={form} onSubmit={handleSubmit}>
                <div className="upload-wrap">
                    <Form.Item
                        label={
                            <>
                                <span className="label-title">Upload Logo *</span>
                                <span className="size-desc">Recommended - Size: 150×150px</span>
                            </>
                        }
                        type="img"
                        rounded
                        name="upload_image"
                        lg
                        uploadTitle="Drag & drop or click to upload JPG, PNG or SVG"
                        disc="Upload Logo"
                        $bgWhite
                        error={error?.logoError}
                        rules={[
                            {
                                required: true,
                                message: "Image is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <Form.Item
                        label={
                            <>
                                <span className="label-title">Upload Your Cover Banner *</span>
                                <span className="size-desc">Recommended - Size: 1317×440px</span>
                            </>
                        }
                        type="img"
                        rounded
                        name="upload_banner"
                        lg
                        uploadTitle="Drag & drop or click to upload JPG, PNG or SVG"
                        disc="Upload Banner"
                        $bgWhite
                        error={error?.bannerError}
                        rules={[
                            {
                                required: true,
                                message: "Banner is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                </div>
                <div className="btn-holder">
                    <Button lg disabled={currentStep === totalSteps}>
                        Preview
                    </Button>
                </div>
            </Form>
        </BusinnesWrap>
    );
};

export default BusinessBranding;
